<template>
    <base-page :title="$t('l.crash_log')" icon="logo-android">
        <Row  slot="extra" type="flex" justify="end">
            <Col>
                <Button type="primary" @click="loadData(page.current)">{{$t('l.fresh')}}</Button>
            </Col>
            <Col class="margin-left-5">
                <res-view :keyName="'fun_exception_delete'">
                    <Button type="primary" @click="onDelete">{{$t('l.delete')}}</Button>
                </res-view>
            </Col>
            <Col class="margin-left-5">
                <res-view :keyName="'fun_exception_empty'">
                    <Button type="error" @click="onEmpty">{{$t('l.clear')}}</Button>
                </res-view>
            </Col>
        </Row>
        <template>
            <Row class="margin-top-10">
                <Table stripe border
                       ref="table"
                       :columns="getColumns"
                       :data="data"
                       :loading="loading"></Table>
            </Row>
            <Row class="margin-top-10" type="flex" justify="center">
                <Col>
                    <Page :current="page.current"
                          :page-size="page.size"
                          :total="page.total"
                          show-elevator
                          @on-change="loadData($event)"
                          size="small">
                    </Page>
                </Col>
            </Row>
        </template>
    </base-page>
</template>

<script>
    import expandRow from './component/exception-expand';
    import util from '@/libs/util';
    import ResView from '../my-components/res-view';
    import BasePage from "../my-components/base-page";

    export default {
        name: "page_crash_log",
        components: {BasePage, ResView},
        data() {
            let that = this;
            return {
                loading: false,
                page: {
                    current: 1,
                    size: 10,
                    total: 0,
                    sortKey: 'id',
                    sortMethod: 'desc',
                    keyword: ''
                },
                columns: [
                    {
                        type: 'selection',
                        align: 'center',
                        width: 60,
                    },
                    {
                        title: 'ID',
                        key: 'id',
                        align: 'center',
                        width: 100
                    },
                    {
                        title: '用户',
                        key: 'realname',
                        align: 'center',
                        width: 180
                    },
                    {
                        title: '手机型号',
                        key: 'model',
                        align: 'center',
                        width: 180
                    },
                    {
                        title: '发生时间',
                        key: 'occur_time',
                        align: 'center',
                        width: 180
                    },
                    {
                        type: 'expand',
                        title: '崩溃信息',
                        align: 'center',
                        key: 'stacktrace',
                        render: (h, params) => {
                            return h(expandRow, {
                                props: {
                                    title: '',
                                    row: {stacktrace: params.row.stacktrace}
                                }
                            });
                        }
                    },
                ],
                data: []
            };
        },
        methods: {
            loadData(page = 1) {
                this.loading = true;
                util.ajax.get('/api/v1/crash/list', {
                    params: {
                        page: page,
                        size: this.page.size,
                        orderKey: this.page.sortKey,
                        orderMethod: this.page.sortMethod,
                        keyword: ""
                    }
                }).then((res) => {
                    this.loading = false;
                    this.page.total = res.data.total;
                    this.data = res.data.list;
                });
            },
            onDelete() { // 删除
                let ids = [];
                if (this.$refs.table.getSelection().length > 0) {
                    for (var row of this.$refs.table.getSelection()) {
                        ids = ids.concat(row.id);
                    }
                    util.ajax.get('/api/v1/crash/delete?ids=' + ids).then((res) => {
                        this.loadData(1);
                    });
                } else {
                    this.$Message.warning('请选择要删除的记录');
                }
            },
            onEmpty() { // 清空
                this.$Modal.confirm({
                    title:'警告',
                    content:"确定清空所有崩溃日志吗？",
                    onOk:()=>{
                        util.ajax.post('/api/v1/crash/empty').then((res) => {
                            this.loadData(1);
                        });
                    },
                })
            },
        },
      computed:{
          getColumns(){
            return  [
              {
                type: 'selection',
                align: 'center',
                width: 60,
              },
              {
                title: 'ID',
                key: 'id',
                align: 'center',
                width: 100
              },
              {
                title: this.$t("l.user_list"),
                key: 'realname',
                align: 'center',
                width: 180
              },
              {
                title: this.$t("l.mobile_model"),
                key: 'model',
                align: 'center',
                width: 180
              },
              {
                title: this.$t("l.occur_time"),
                key: 'occur_time',
                align: 'center',
                width: 180
              },
              {
                type: 'expand',
                title: this.$t('l.error'),
                align: 'center',
                key: 'stacktrace',
                render: (h, params) => {
                  return h(expandRow, {
                    props: {
                      title: '',
                      row: {stacktrace: params.row.stacktrace}
                    }
                  });
                }
              },
            ]
          },
      },
        mounted() {
            this.loadData();
        }
    }
</script>

<style scoped>

</style>